/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  function configurer(){

    ScrollReveal().reveal('.fade-left', { delay: 0, scale: 0.98, distance: "25px", origin: 'left', duration: 1000 });
    ScrollReveal().reveal('.fade-up', { delay: 0, scale: 0.98, distance: "15px", duration: 1000 });
    ScrollReveal().reveal('.fade-right', { delay: 0, scale: 0.98, distance: "25px", origin: 'right', duration: 1000 });

    ScrollReveal().reveal('.fade-up-delay', { delay: 0, distance: "100px", origin: 'bottom', duration: 1000 });
    ScrollReveal().reveal('.fade-bottom-delay', { delay: 0, distance: "100px", origin: 'top', duration: 1000 });

    $('.front-slider').slick({
      arrows: false,
      dots: true,
      autoplay: true
    });

    $('.apropos-slider').slick({
      arrows: true,
      dots: false,
      fade: true,
      autoplay: true
    });

    $('.ambassadeur-lifestyle-slider').slick({
      arrows: true,
      dots: false,
      fade: true,
      autoplay: true
    });

    $('.product-lifestyle-slider').slick({
      arrows: true,
      dots: false,
      fade: true,
      autoplay: true
    });

    $('.product-slider').slick({
      arrows: false,
      dots: false,
      fade: true,
      adaptiveHeight: true,
    });

    $('.product-slider-nav').slick({
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      slidesToShow: 4,
      infinite: true,
    });

    $('.product-slider-nav .slide').on('click', function() {
      var slideIndex = $(this).attr('data-slick-index');

      /*$('.product-slider-nav .slide.active').removeClass('active');

      $(this).addClass('active');*/

      $('.product-slider').slick('slickGoTo',slideIndex);
      $('.product-slider-nav').slick('slickGoTo',slideIndex);

    });

    var cpt = 0;

    $('.product-slider-nav .slide[data-slick-index="0"]').addClass('active');

    $('.product-slider').on('afterChange', function(event, slick, currentSlide){

      $('.product-slider-nav .slide.active').removeClass('active');
      $('.product-slider-nav .slide[data-slick-index="'+currentSlide+'"]').addClass('active');

    });

    //MENU / NAVIGATION
    var lastScrollTop = 0;
    $(window).scroll(function(event){
      var st = $(this).scrollTop();

      if (st > lastScrollTop){
        if(st >= 50){
          $('body').addClass('scrolled');
        }
      } else {          
        if(st <= 50){
          $('body').removeClass('scrolled');
        }
      }

      lastScrollTop = st;
    });

    $('#menu-toggle').on('click', function() {
      $('#top-bar').toggleClass('menu-open');
      $('body').toggleClass('no-scroll');

      return false;
    });

    $('.btn-warranty').on('click', function() {
      $('.home-warranty-readmore').slideToggle();

      $(this).toggleClass('active');

      return false;
    });

    $('.filters-list li').on('click', function() {

      if($('#ambas-list').length > 0){
        $('.filters-list li.active').removeClass('active');
        $(this).addClass('active');

        var cat_id = $(this).attr('data-id');

        if(cat_id == -1){
          resetAmbasGrid();

           $('.ambas-list .ambassadeur').each(function() {

            var current = $(this);

            setTimeout(function(){
               current.slideDown();
            }, 500);

           })
        }else {
          $('.ambas-list .ambassadeur').each(function() {

          var selected_id = $(this).attr('data-id');
          var arr_id = selected_id.split(',');   

          resetAmbasGrid();

          var current = $(this);

          setTimeout(function(){
             if(jQuery.inArray(cat_id, arr_id)){
              current.slideUp();
            }else {
              current.slideDown();
            }
          }, 500);

        });
        }
      }else {

        $('.filters-list li.active').removeClass('active');
        $(this).addClass('active');

        var cat_id = $(this).attr('data-id');

        if(cat_id == -1){
          resetCanotsGrid();

           $('.canots-list .canot').each(function() {

            var current = $(this);

            setTimeout(function(){
               current.slideDown();
            }, 500);

           })
        }else {
          $('.canots-list .canot').each(function() {

          var selected_id = $(this).attr('data-id');
          var arr_id = selected_id.split(',');

          resetCanotsGrid();

          var current = $(this);

          setTimeout(function(){
             if(jQuery.inArray(cat_id, arr_id)){
              current.slideDown();
            }else {
              current.slideUp();
            }
          }, 500);

        });
        }

      }
    });

    $('.accordeon .titre').on('click', function() {
      $(this).parent().toggleClass('open');
      $(this).parent().find('.contenu').slideToggle();

    });

    $('.care-label-trigger').on('click', function() {
      $('#care-label-lightbox').addClass('open');
    });


    $('.care-label-lightbox-close').on('click', function() {
      
      $('#care-label-lightbox.open .container-small').addClass('hiding');
      $('#care-label-lightbox').addClass('hiding');

      setTimeout(function() {
        $('#care-label-lightbox.open .container-small').removeClass('hiding');
        $('#care-label-lightbox').removeClass('hiding');
        $('#care-label-lightbox').removeClass('open');
      }, 500);

      
    });

    $('.tags-list.parent li').on('click', function() {
      var parent_id = $(this).attr('data-id');

      if($(this).hasClass('active')){

        $('.tags-list.parent li.active').removeClass('active');
        $('.tags-list.child.active').slideUp();
        $('.tags-list.child.active').removeClass('active');

      }else {
        $('.tags-list.parent li.active').removeClass('active');
        $('.tags-list.child.active').slideUp();
        $('.tags-list.child.active').removeClass('active');

        $(this).addClass('active');
        $('.tags-list.child[parent-id="'+parent_id+'"]').slideDown();
          setTimeout(function() {
            $('.tags-list.child[parent-id="'+parent_id+'"]').addClass('active');
          }, 500);
      }        

    });   

    $('.tags-list.child li').on('click', function() {
        var data_id = $(this).attr('data-id');
        var tag_title = $(this).text();

        if(!$(this).hasClass('active')){
         

          $(this).parent().parent().slideUp();   
          

          if($(this).parent().find('li.active').length){
            //Si une catégorie est deja selectionnée
            var data_id_parent = $(this).parent().find('li.active').attr('data-id');
            var data_id = $(this).attr('data-id');

            //CANCEL ACTIF            
            removeSelectedTags(data_id_parent);
            resetCanotsGrid();
            $('.tags-list.child li[data-id="'+data_id_parent+'"]').removeClass('active');
            $('.selected-tags ul li[data-id="'+data_id_parent+'"] ').remove();

            //AJOUT NOUVEAU
            $('.tags-list.parent li.active').removeClass('active');
            $('.selected-tags ul').append('<li data-id="'+data_id+'">'+tag_title+'<span><span>+</span></span></li>');
              if($('.selected-tags').hasClass('hidden')){
              $('.selected-tags').slideDown();
              $('.selected-tags').removeClass('hidden');
            }


            $('.selected-tags ul li').on('click', function() {            

                var data_id = $(this).attr('data-id');

                removeSelectedTags(data_id);

                $('.tags-list.child ul li[data-id="'+data_id+'"]').removeClass('active');

                $(this).remove();

                if($('.selected-tags ul li').length == 0){
                  $('.selected-tags').slideUp();
                  $('.selected-tags').addClass('hidden');
                }

                resetCanotsGrid();

            });

            appendSelectedTags(data_id);

            $(this).addClass('active');


          }else {
            $('.tags-list.parent li.active').removeClass('active');

            $('.selected-tags ul').append('<li data-id="'+data_id+'">'+tag_title+'<span><span>+</span></span></li>');
              if($('.selected-tags').hasClass('hidden')){
              $('.selected-tags').slideDown();
              $('.selected-tags').removeClass('hidden');
            }

            $('.selected-tags ul li').on('click', function() {            

                var data_id = $(this).attr('data-id');

                removeSelectedTags(data_id);

                $('.tags-list.child ul li[data-id="'+data_id+'"]').removeClass('active');

                $(this).remove();

                if($('.selected-tags ul li').length == 0){
                  $('.selected-tags').slideUp();
                  $('.selected-tags').addClass('hidden');
                }

                resetCanotsGrid();

            });

            appendSelectedTags(data_id);

            $(this).addClass('active');
          }

          
                 
          
           

          
          resetCanotsGrid();

        }else {


          $(this).removeClass('active');
          removeSelectedTags(data_id);
          resetCanotsGrid();
          $('.selected-tags ul li[data-id="'+data_id+'"] ').remove();



          if($('.selected-tags ul li').length == 0){
            $('.selected-tags').slideUp();
            $('.selected-tags').addClass('hidden');
          }

        }            

    });



    if($(window).width() <= 1024){
      $('#top-bar .menu-item-has-children').on('click', function() {
          $(this).find('.sub-menu').slideToggle();
          $(this).toggleClass('sub-menu-open');
      });
    }else {
      if($('body').hasClass('mobile-device')){     

        $('#top-bar ul li.menu-item-has-children').on('click', function() {
          $(this).toggleClass('sub-menu-visible');

        })
      }
    }

    var bottom_bar_height = getBottomBarHeight();

    $('body').css('margin-bottom', bottom_bar_height);

    $(window).on('resize', function() {
      var bottom_bar_height = getBottomBarHeight();
      $('body').css('margin-bottom', bottom_bar_height);
    });

    $('body').addClass('loaded');

  }

  function appendSelectedTags(tag_id){
    var current_val = $('#selected-tags-input').val();

    if(!current_val){
      current_val = tag_id;
    }else {
      current_val = current_val+','+tag_id;
    }    

    $('#selected-tags-input').val(current_val);

  }

  function removeSelectedTags(tag_id){
    var current_val = $('#selected-tags-input').val();

    current_val = current_val.split(",");

    index = current_val.indexOf(tag_id);

    if (index > -1) {
      current_val.splice(index, 1);
    }

    current_val = current_val.toString();

    $('#selected-tags-input').val(current_val);



  }


  function resetCanotsGrid() {

    $('.canots-list').css('opacity', 0);

    var selected_tags = $('#selected-tags-input').val();

    if(!selected_tags){

      $('.canots-list .canot').each(function() {
          var current = $(this);

          setTimeout(function() {
              current.slideDown();
            }, 500);

      });
    }else {
        page_selected_tags = selected_tags.split(',');

        $('.canots-list .canot').each(function() {
          var current_tags = $(this).attr('tag-list');
          current_tags = current_tags.split(',');

          var visible = true;
          var current = $(this);
          var i;

          for (i = 0; i < page_selected_tags.length; i++) {
            var id = page_selected_tags[i];

            var index = current_tags.indexOf(id);

            if(index == -1){
              visible = false;
            }           

          }

          if(visible == false){
            setTimeout(function() {
              current.slideUp();
            }, 500);
            
          }else {
            setTimeout(function() {
              current.slideDown();
            }, 500);
          } 

        });
    }

    


    setTimeout(function(){
      $('.canots-list').css('opacity', 1);      
    }, 1000);

  }

  function getBottomBarHeight() {
    return $('footer .bottom-bar').height();
  }

  function resetAmbasGrid() {

    $('.ambas-list').css('opacity', 0);

    setTimeout(function(){
      $('.ambas-list').css('opacity', 1);      
    }, 1000);

  }




  window.onload = configurer;

  // Load Events
  $(document).ready(UTIL.loadEvents);



    

})(jQuery); // Fully reference jQuery after this point.
